(function () {
    try {
      /* main variables */
      var debug = 0;
      var variation_name = "";
      var $;
      
      /* all Pure helper functions */
      function waitForElement(selector, trigger, delayInterval, delayTimeout) {
        var interval = setInterval(function () {
          if (
            document &&
            document.querySelector(selector) &&
            document.querySelectorAll(selector).length > 0
          ) {
            clearInterval(interval);
            trigger();
          }
        }, delayInterval);
        setTimeout(function () {
          clearInterval(interval);
        }, delayTimeout);
      }
  
      const stickyBox =
        `<div class="eg-sticky-left">
            <div class="eg-rating">
              <span class="eg-rating-count "></span>
              <span class="eg-stars"></span>
              <span class="eg-reviews"></span>
            </div>
          </div>`;
  
      function init() {
        document.body.classList.add('AB001');
  
        const adv = document.querySelector('.shopify-section .adv');
        if (adv && !document.querySelector('.eg-sticky-left')) {
          adv.insertAdjacentHTML('afterbegin', stickyBox);
        }
  
        const strongElement = document.querySelector(".banner-stars + .text-s > strong:first-of-type");
        const starsElement = document.querySelector(".banner-stars");
        const reviewText = document.querySelector(".banner-stars + .text-s > strong:last-of-type")?.innerText;
  
        if (reviewText) {
          document.querySelector(".eg-reviews").innerText = `+${reviewText}`;
        }
        if (strongElement) {
          document.querySelector(".eg-rating-count").textContent = strongElement.textContent.split("/")[0].trim();
        }
        if (starsElement) {
          document.querySelector(".eg-stars").innerHTML = starsElement.innerHTML;
        }
        if (adv) {
          const childDivs = adv.querySelectorAll('div');
            const wrapper = document.createElement('div');
            wrapper.className = 'eg-parent-wrapper';
            wrapper.appendChild(childDivs[0]);
            wrapper.appendChild(childDivs[2]);
            adv.insertAdjacentElement('afterbegin', wrapper);
        }
        const egStickyLeft= document.querySelector('.eg-sticky-left');
        const advButton = document.querySelector('.shopify-section .adv-button');
        if (window.innerWidth <= 767 && egStickyLeft && advButton) {
            advButton.insertAdjacentElement('afterend', egStickyLeft);
        }
      }
  
      /* Initialize variation */
      waitForElement('.banner-stars', init, 50, 15000);
    } catch (e) {
      if (debug) console.log(e, "error in Test" + variation_name);
    }
  })();